document.addEventListener("DOMContentLoaded", function () {
  const $slider = $('.frequently-bought-together__section .row');
  if ($slider.length) {
    $slider.slick({
      dots: true,
      arrows: false,
      infinite: false,
      slidesToShow: 1.5,
      slidesToScroll: 1,
      mobileFirst: true,
      row: 1,
      accessibility: false,
      responsive: [
        {
          breakpoint: 768,
          settings: 'unslick'
        }
      ]
    });
  }
});